import { clsx } from 'clsx'
import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCheck } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../../../generic-hooks'

import { RxLpChHeroDescriptionNowSaveModalTrigger } from './RxLpChHeroDescriptionNowSaveModalTrigger'
import { RxNowSaveModal } from './RxNowSaveModal'

import styles from './Hero.module.css'

const accentuate = (text: ReactNode[]): JSX.Element => (
  <h1
    className={clsx(
      styles['hero-content-title-text'],
      'inline text-dark-primary-max',
    )}
  >
    {text}
  </h1>
)

export const RxLpChHeroDescription: FC = () => {
  const modalControls = useOpenableControls()

  return (
    <div className="flex flex-col tablet:items-center tablet:justify-center tablet:gap-4">
      <div
        className={clsx(
          styles['hero-content-title'],
          'text-2xl italic leading-xl text-dark-accent tablet:text-3xl tablet:leading-3xl tablet:tracking-3xl',
        )}
      >
        <FormattedMessage
          id="rx.ch.hero.title.new"
          values={{
            accentuate,
          }}
        />
      </div>
      <div
        className={clsx(
          styles['hero-content-description'],
          'text-m font-normal leading-s tablet:text-l tablet:leading-m',
        )}
      >
        <Button<'a'>
          className="mt-4 w-full tablet:mt-0"
          color="primary"
          href="#rx-form"
          size="medium"
          slots={{ root: 'a' }}
          variant="filled"
        >
          <FormattedMessage id="rx.com.hero.cta.new" />
        </Button>
        <div className="mt-4 flex flex-col">
          <div className="mb-4 justify-center text-l font-medium tablet:mb-2 tablet:pb-2">
            <h4>
              <FormattedMessage id="rx.ch.description.subheader" />
            </h4>
          </div>
          <div className="flex flex-row justify-start text-s tablet:pb-2">
            <span className="mr-2 shrink-0">
              <IconCheck className="inline-block size-6 fill-dark-primary-max" />
            </span>
            <p className="mb-1">
              <FormattedMessage id="rx.com.hero.description.item.new.1" />
            </p>
          </div>
          <div className="flex flex-row justify-start text-s tablet:pb-2">
            <span className="mr-2 shrink-0">
              <IconCheck className="inline-block size-6 fill-dark-primary-max" />
            </span>
            <p className="mb-1">
              <FormattedMessage id="rx.com.hero.description.item.new.2" />
            </p>
          </div>
          <div className="mb-1 flex flex-row justify-start text-s">
            <span className="mr-2 shrink-0">
              <IconCheck className="inline-block size-6 fill-dark-primary-max" />
            </span>
            <p className="mb-1 text-start">
              <FormattedMessage id="rx.com.hero.description.item.new.3" />
              <RxLpChHeroDescriptionNowSaveModalTrigger
                onClick={modalControls.handleOpen}
              />
            </p>
          </div>
          <RxNowSaveModal modalControls={modalControls} />
          <div className="flex flex-row justify-start text-s">
            <span className="inset-0 mr-2 shrink-0">
              <IconCheck className="inline-block size-6 fill-dark-primary-max" />
            </span>
            <p>
              <FormattedMessage id="rx.com.hero.description.item.new.4" />
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
